import { render } from "./Color.vue?vue&type=template&id=1de4ab4c&scoped=true&ts=true"
import script from "./Color.vue?vue&type=script&lang=ts"
export * from "./Color.vue?vue&type=script&lang=ts"

import "./Color.vue?vue&type=style&index=0&id=1de4ab4c&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1de4ab4c"]])

export default __exports__